import React from 'react';
const tomi = [{
  num: '1',
  title: 'I Segreti del Reset',
  desc: "Come disinfiammare l'intestino e riattivare il metabolismo."
}, {
  num: '2',
  title: 'Ricette Express (15 Min)',
  desc: 'Oltre 100 piatti pronti nel tempo di apparecchiare la tavola.'
}, {
  num: '3',
  title: 'Sazietà Mediterranea',
  desc: 'Ricette proteiche per non avere mai più fame tra i pasti.'
}, {
  num: '4',
  title: 'Meal Prep Master',
  desc: 'Il sistema per organizzare tutta la tua settimana in soli 90 minuti.'
}, {
  num: '5',
  title: 'PROTOCOLLO ANTI-GONFIORE',
  desc: 'Il tuo "pronto soccorso" per sgonfiare l\'addome in 48 ore.'
}, {
  num: '6',
  title: 'Estate & Leggerezza',
  desc: 'Piatti freschi e idratanti per sentirti al top ogni giorno.'
}];
export function TomiSection() {
  return <section className="py-6 sm:py-12 px-4 bg-brand-cream" data-id="element-156">
      <div className="max-w-2xl mx-auto" data-id="element-157">
        <div className="text-center mb-5 sm:mb-8" data-id="element-158">
          <h2 className="text-xl sm:text-3xl font-serif font-bold text-brand-text-main mb-2 sm:mb-3" data-id="element-159">
            L'Enciclopedia Reset Mediterraneo™
          </h2>
          <p className="text-sm sm:text-base text-brand-text-muted font-medium mb-2" data-id="element-160">
            La Biblioteca definitiva: Oltre 500 Ricette e Soluzioni Rapide
            (Niente da studiare, solo da applicare)
          </p>
          <p className="text-xs sm:text-sm text-brand-text-muted" data-id="element-161">
            Abbiamo eliminato la teoria noiosa. Riceverai 6 Guide Operative
            progettate per darti risultati immediati:
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-162">
          {tomi.map((t, i) => <div key={i} className="bg-white border border-brand-sage/30 p-4 sm:p-5 rounded-xl flex gap-3 sm:gap-4 items-start" data-id="element-163">
              <div className="bg-brand-olive text-white text-xs font-black px-2.5 py-1 rounded shrink-0 mt-0.5" data-id="element-164">
                GUIDA {t.num}
              </div>
              <div data-id="element-165">
                <h3 className="font-bold text-brand-olive text-sm sm:text-base mb-1" data-id="element-166">
                  {t.title}
                </h3>
                <p className="text-brand-text-muted text-xs sm:text-sm leading-snug" data-id="element-167">
                  {t.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}